export default "__VITE_ASSET__7657a1b6__"